import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { RootState } from 'types'
import { FavoritableType } from 'api/clients/FavoriteClient'
import Tree, { TreeData } from 'tree-dnd'
import { TreeRow } from 'components/LocationPicker/components/FileTreeLocationPicker/components/FilesTree/components/TreeRow'

import Styles from '../../FileTreeLocationPicker.module.scss'
import { SelectedFolder } from 'components/LocationPicker/LocationPicker'
import { mapFavoritesToTreeItems } from 'blaze-components/WorkspaceDashboardSidebar/components/Favorites/FavoritesTree/useFavoritesTree'
import { toTree } from 'blaze-components/WorkspaceDashboardSidebar/components/FilesTree/treeUtils'
import { ExpandableTree, useExpandable } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useExpandable'
import { SectionHeader } from 'components/SectionHeader/SectionHeader'

interface Props {
  workspaceId: number
  onSelect: (folder: SelectedFolder | null) => void
  disabledFolderIds?: string[]
}

const Favorites = observer(({ workspaceId, onSelect, disabledFolderIds = [] }: Props) => {
  const [favoritesTree, setFavoritesTree] = useState<TreeData>()
  const { toggle, expanded } = useExpandable(ExpandableTree.Favorites)

  const favorites = useSelector(
    ({ favorites }: RootState) =>
      favorites.filter(
        ({ favoritable_workspace_id, favoritable_type }) =>
          favoritable_workspace_id === workspaceId && favoritable_type === FavoritableType.Project,
      ),
    isEqual,
  )

  useEffect(() => {
    const favoriteTreeItems = mapFavoritesToTreeItems(favorites)

    if (!favoriteTreeItems) return

    setFavoritesTree(toTree(favoriteTreeItems))
  }, [favorites, setFavoritesTree])

  if (favorites.length < 1) {
    return null
  }

  return (
    <li className={Styles.section}>
      <SectionHeader label="Favorites" isExpanded={expanded} onPress={toggle} size="sm" />
      {expanded && favoritesTree && (
        <Tree
          tree={favoritesTree}
          renderItem={(props) => (
            <TreeRow {...props} onCollapse={() => {}} onSelect={onSelect} disabledFolderIds={disabledFolderIds} />
          )}
          renderDropPlaceholder={() => null}
        />
      )}
    </li>
  )
})

export { Favorites }
